
import React from 'react';

export const BirdEyeViewSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            조감도 예시
          </h2>
          <p className="text-lg text-gray-600">
            대청마을 북측 개발 완료 후 예상 조감도
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          {/* YouTube 동영상 */}
          <div className="relative mb-12">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="relative" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/rrtj_tPtaPs"
                  title="대청마을 북측 조감도 영상"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>

          {/* 메인 조감도 */}
          <div className="relative mb-12">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/4a2a6b477d2273a3d0d5c5a7079aba9a/e77ad896606ac96d3bb0628e0912f77d.jpeg"
                  alt="대청마을 북측 조감도 예시"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md">
                  <p className="text-sm font-semibold text-gray-900">조감도 예시</p>
                </div>
              </div>
            </div>
          </div>

          {/* 추가 조감도 이미지 */}
          <div className="relative mb-12">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/4a2a6b477d2273a3d0d5c5a7079aba9a/ffc2b43b4a4ce77b36ba816777d20d22.jpeg"
                  alt="대청마을 북측 프리미엄 조감도"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md">
                  <p className="text-sm font-semibold text-gray-900">프리미엄 조감도</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* 조감도 설명 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">개발 후 예상 모습</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-building-line text-blue-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">현대적 고층 아파트 단지</p>
                    <p className="text-gray-600">최신 건축 기법을 적용한 프리미엄 주거 공간</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-eye-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">한강 조망권 확보</p>
                    <p className="text-gray-600">모든 세대에서 한강과 도심을 조망할 수 있는 배치</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-leaf-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">친환경 단지 조성</p>
                    <p className="text-gray-600">녹지 공간과 조화를 이루는 지속가능한 개발</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-road-map-line text-purple-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">체계적 도로망 구축</p>
                    <p className="text-gray-600">원활한 교통 흐름을 위한 도로 인프라 개선</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">핵심 특징</h3>
              <div className="space-y-4">
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-home-line text-blue-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">프리미엄 주거 환경</p>
                  </div>
                  <p className="text-sm text-gray-600">강남권 최고급 주거 단지 수준의 품격있는 생활 공간</p>
                </div>
                
                <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-landscape-line text-green-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">자연과의 조화</p>
                  </div>
                  <p className="text-sm text-gray-600">한강과 주변 녹지를 활용한 친환경적 단지 설계</p>
                </div>
                
                <div className="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-community-line text-purple-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">커뮤니티 시설</p>
                  </div>
                  <p className="text-sm text-gray-600">주민 편의를 위한 다양한 부대시설 및 커뮤니티 공간</p>
                </div>
                
                <div className="bg-orange-50 rounded-lg p-4 border-l-4 border-orange-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-car-line text-orange-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">편리한 교통망</p>
                  </div>
                  <p className="text-sm text-gray-600">강남 중심가와 연결되는 최적의 교통 접근성</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* 추가 정보 */}
          <div className="mt-12 bg-gray-50 rounded-xl p-8">
            <div className="text-center mb-6">
              <h4 className="text-xl font-bold text-gray-900 mb-2">개발 완료 후 기대효과</h4>
              <p className="text-gray-600">대청마을 북측 개발이 완료되면 다음과 같은 효과를 기대할 수 있습니다</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-line-chart-line text-2xl text-blue-600"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-2">자산가치 상승</h5>
                <p className="text-sm text-gray-600">강남권 프리미엄 입지로 인한 지속적인 자산가치 증대</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-line text-2xl text-green-600"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-2">삶의 질 향상</h5>
                <p className="text-sm text-gray-600">최고급 주거 환경과 편의시설로 인한 생활 만족도 증대</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-global-line text-2xl text-purple-600"></i>
                </div>
                <h5 className="font-semibold text-gray-900 mb-2">지역 발전</h5>
                <p className="text-sm text-gray-600">주변 지역 개발 촉진 및 인프라 개선 효과</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
